import Box from '@mui/material/Box';
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getHeaderProjects } from '../../../modules/project';
import { listAllUsers } from '../../../modules/users';
import ProjectDropDown from './ProjectDropDown';
import UserDropDown from './UserDropDown';
import { useRole, useUserAccess } from '../../../hooks/useRole';
import QUERY_KEYS from '../../../query/queryKeys';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NavbarDropdowns = () => {
  const role = useRole();
  const navigate = useNavigate();
  const { canSeeAllDefects, isLoading } = useUserAccess();

  const { data: projectList = [], refetch: fetchProjectList } = useQuery({
    queryKey: QUERY_KEYS.project.headerProjects(),
    queryFn: getHeaderProjects,
    enabled: !!role && role !== 'super-admin',
  });

  const { data: userData, refetch: fetchUserData } = useQuery({
    queryKey: QUERY_KEYS.users.headerUsers({ perPage: 5 }),
    queryFn: () => listAllUsers(5),
    enabled: !!role && (role === 'org-admin' || role === 'org-manager'),
  });

  const users = userData?.users || [];

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
      {role !== 'super-admin' && (
        <ProjectDropDown
          projectList={projectList}
          fetchprojectList={fetchProjectList}
        />
      )}
      {(role === 'org-admin' || role === 'org-manager') && (
        <UserDropDown users={users} fetchUserData={fetchUserData} />
      )}
      {!isLoading && canSeeAllDefects &&
        <Button
          id="reports"
          variant="text"
          disableElevation
          sx={{ color: 'var(--primary-color)', fontWeight: 'bold', ml: 5 }}
          onClick={() => handleNavigate('/reports')}
        >
          Reports
        </Button>
      }
    </Box>
  );
};

export default NavbarDropdowns;
